import Vue from 'vue'
import MessageHost from '@/components/Message.vue'

const MessageConstructor = Vue.extend(MessageHost)
let instance

function getInstance () {
  if (!instance) {
    instance = new MessageConstructor()
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
  }
  return instance
}

function show (options) {
  const opts = typeof options === 'string' ? { message: options } : options
  return getInstance().add({
    message: opts.message,
    type: opts.type || 'info',
    duration: opts.duration != null ? opts.duration : 3000
  })
}

const message = {
  close (id) {
    if (id != null) getInstance().remove(id)
  },
  info (msg, duration) {
    return show({ message: msg, type: 'info', duration })
  },
  success (msg, duration) {
    return show({ message: msg, type: 'success', duration })
  },
  warning (msg, duration) {
    return show({ message: msg, type: 'warning', duration })
  },
  error (msg, duration) {
    return show({ message: msg, type: 'error', duration })
  }
}

export default message



// WEBPACK FOOTER //
// ./src/utils/message.js